export var STORAGE;
(function (STORAGE) {
    STORAGE["USER_CONTEXT"] = "user_context";
})(STORAGE || (STORAGE = {}));
